<div class="row">
    <div class="col-12" style="margin-top: 100px;">
    </div>
</div>

<div class="row" *ngIf="!orderData">
    <div class="col-12" style="margin-top: 400px;">
    </div>
</div>

<div class="container" *ngIf="orderData">
    <div class="row">
        <div class="col-12" style="margin-top: 20px;">
        </div>
    </div>
    <div class="alert alert-success" role="alert"
        *ngIf="orderData && orderData.status && orderData.status.text == 'Paid'">
        <h4 class="alert-heading">
            Payment Successful
        </h4>
        <p>Your payment has been successfully processed.</p>
        <hr>
        <p class="mb-0">Thank you for your payment!</p>
    </div>

    <!-- Payment Pending -->
    <div class="alert alert-warning" role="alert"
        *ngIf="orderData && orderData.status && orderData.status.text == 'Pending'">
        <h4 class="alert-heading">
            Payment Pending
        </h4>
        <p>Your payment is pending. Please wait for confirmation.</p>
        <hr>
        <p class="mb-0">We appreciate your patience.</p>
    </div>

    <!-- Payment Failed -->
    <div class="alert alert-danger" role="alert"
        *ngIf="orderData && orderData.status && orderData.status.text == 'Declined'">
        <h4 class="alert-heading">
            Payment Failed
        </h4>
        <ng-container *ngIf="orderData.transaction && orderData.transaction.message">
            <p>{{orderData.transaction.message}}</p>
        </ng-container>
        <ng-container *ngIf="!orderData.transaction || !orderData.transaction.message">
            <p>There was an issue processing your payment. Please try again later.</p>
            <hr>
            <p class="mb-0">We apologize for any inconvenience caused.</p>
        </ng-container>

    </div>

    <ng-container *ngIf="orderData && orderData.status && orderData.status.text == 'Paid'">
        <app-invoice [invoiceData]="invoiceData"></app-invoice>       
        <div class="text-center mt-3 mb-5">
            <button class="btn btn-primary btn-theme mx-2" (click)="printInvoice()">Print</button>
        </div>
    </ng-container>

</div>